/**
 * Converts the shape returned by `useSlotOccupancy.filledByChannel` into the
 * `CurrentSlotsByChannel` snapshot that `usePendingChannelDrops.add()` needs
 * to plan insert-with-shift.
 *
 * Slots without a `linkId` are dropped defensively — the save() pipeline can
 * only reorder existing slots when it has their link-id. The channel itself
 * still appears in the resulting map (possibly empty), so callers can tell
 * "channel exists but is empty" from "channel unknown".
 */
import type { ChannelSlotFill } from './useSlotOccupancy'
import type { CurrentSlotsByChannel } from './usePendingChannelDrops'
import type { AddToProductImage } from '../types'

export function buildOccupancySnapshot(
  filledByChannel: Record<string, Record<number, ChannelSlotFill>>,
): CurrentSlotsByChannel {
  const out: CurrentSlotsByChannel = new Map()
  for (const [channelId, slots] of Object.entries(filledByChannel)) {
    const slotMap: Record<number, { linkId: string; image: AddToProductImage }> = {}
    for (const [slotStr, fill] of Object.entries(slots)) {
      if (!fill.linkId || !fill.assetId) continue
      slotMap[Number(slotStr)] = {
        linkId: fill.linkId,
        image: { id: fill.assetId, url: fill.url, kind: 'asset' },
      }
    }
    out.set(channelId, slotMap)
  }
  return out
}
